@if ({
  theme: theme$ | async,
  isLogged: isLogged$ | async,
  }; as content) {
  <div class="{{ content.theme }} {{ content.isLogged ? 'is-logged' : 'not-logged' }}">
    <custom-cx-store-front></custom-cx-store-front>
  </div>
}
